import React from 'react';
import MyCustomLogoFull from './logo/logo_negative.png';


const LogoFull = () => {
  return (
    <img 
      src={MyCustomLogoFull} 
      alt="AllFunds" // Add an alt attribute for accessibility
      style={{
        width: '150px'
      }}
    />
  );
};

export default LogoFull;

